import { computed } from "vue";

export default {
  data() {
    return {
      tenantId: this.realm,
      apiUrl: this.digitalTwinModelConversionConfig.api,
    };
  },
  created() {},
  provide() {
    return {
      modelDT: computed(() => this.modelDT),
    };
  },
  methods: {
    async postExportModel() {
      if (this.modelDT) {
        try {
          const sessionStorageModelObject = this.getModelToSessionStorage();
          sessionStorageModelObject.standards = this.selectedStandards;
          const response = await this.axios.post(
            this.apiUrl + "/" + this.tenantId + "/models/export",
            sessionStorageModelObject,
            this.opts,
          );

          if (response?.data) {
            this.disabledButtonExport = true;
            this.exportModels = undefined;
            this.validationExportModel = [];
            this.selectedStandardsDispaly = this.availableStandards.filter(
              (e) => this.selectedStandards.includes(e.value),
            );
            this.saveModelToSessionStorage({
              ...sessionStorageModelObject,
            });
            this.getExportModel();
          }
        } catch (error) {
          this.disabledButtonExport = false;
          this.selectedStandardsDispaly = undefined;
          this.exportModels = undefined;
          this.validationExportModel = [];
          this.setError(error, false, undefined, true);
        }
      }
    },
    getExportModel() {
      this.axios
        .post(
          this.apiUrl +
            "/" +
            this.tenantId +
            "/models/getExport/" +
            this.modelDT.modelId,
          this.selectedStandards,
          this.opts,
        )
        .then((response) => {
          this.exportModels = response.data.standards;
          this.disabledButtonExport = true;
        })
        .catch((err) => {
          this.disabledButtonExport = false;
          this.selectedStandardsDispaly = undefined;
          this.exportModels = undefined;
          this.validationExportModel = undefined;
          this.setError(err, false, undefined, true);
        });
    },
    getModelToSessionStorage() {
      return JSON.parse(sessionStorage.getItem("digital-twin-model"));
    },
    saveModelToSessionStorage(data) {
      sessionStorage.setItem("digital-twin-model", JSON.stringify(data));
      this.modelDT = data;
    },

    clearValidationExportModel() {
      this.validationExportModel = [];
    },
    addValidationExportModel(validation) {
      this.validationExportModel.push(validation);
    },

    snackbarEvent(value, text) {
      this.snackbar = value;
      this.snackbarText = text;
    },
    //Abort the model creation
    abortModel() {
      sessionStorage.removeItem("digital-twin-model");
      this.routeTo(`/dts`);
    },
    //Goes to a new path
    routeTo(newPath) {
      this.$router.push({
        path: newPath,
      });
    },
  },
};
